var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-screen',{scopedSlots:_vm._u([(_vm.showGroupTree)?{key:"aside",fn:function(){return [_c('page-group-tree',{staticClass:"mt-2"})]},proxy:true}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }